import { getIndicatorEventDefinitions } from '../utils/indicatorEvents';

const indicatorEventDefinitions = getIndicatorEventDefinitions();

export const INDICATOR_EVENT_DEFINITIONS = indicatorEventDefinitions;
export const DWLF_EVENT_TYPES = indicatorEventDefinitions.map((definition) => definition.id);
export const EVENT_TYPE_LABELS = indicatorEventDefinitions.reduce((acc, definition) => {
  acc[definition.id] = definition.name ?? definition.id;
  return acc;
}, {});

const formatFallbackLabel = (value) => {
  if (typeof value !== 'string' || value.length === 0) {
    return '';
  }
  return value
    .replace(/[._]/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

// Labels for subscribable event types that aren't indicator events (so they're
// absent from INDICATOR_EVENT_DEFINITIONS) — e.g. the opt-in daily briefing
// digest. Without this the fallback would render "Briefing Digest Daily".
export const EXTRA_EVENT_TYPE_LABELS = {
  'briefing.digest.daily': 'Daily briefing digest',
};

export const getEventTypeLabel = (type) =>
  EVENT_TYPE_LABELS[type] || EXTRA_EVENT_TYPE_LABELS[type] || formatFallbackLabel(type);
